import { render, staticRenderFns } from "./omProblemLog.vue?vue&type=template&id=18e6b7b8"
import script from "./omProblemLog.ts?vue&type=script&lang=js&external"
export * from "./omProblemLog.ts?vue&type=script&lang=js&external"
import style0 from "./omProblemLog.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports